import React from "react";
import { Typography, Grid, Box, Container, Button } from "@mui/material";
import Frame from "../../assets/frame2.png";

export default function Trans() {
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item xs={12} md={6} lg={6}>
        <img src={Frame} width="100%" />
      </Grid>
      <Grid item xs={12} md={5} lg={5}>
        <Typography className="trans_typo1">Use FixelPay</Typography>

        <Typography className="lower_typo2" mt={5}>
          Exhanging your money to other currencies shouldn’t be hard. Life is
          simple, Fixelpay makes it simpler so get your groove on!
        </Typography>
        <Button className="main_btn2" sx={{ mt: 5 }}>
          Learn more
        </Button>
      </Grid>
    </Grid>
  );
}
